import React, { CSSProperties, ReactNode, FC } from 'react';
import { Box, Card, Modal, Typography } from '@mui/material';
import useLocales from 'hooks/useLocales';

import './Index.scss';

interface AIModalProps {
  open: boolean;
  onClose?: () => void;
  customAvatar?: string;
  customTitle?: string;
  customMessage?: string;
  titleStyle?: CSSProperties;
  textStyle?: CSSProperties;
  customButton?: ReactNode;
  description?: string;
}

const AIModal: FC<AIModalProps> = ({
  open,
  onClose,
  customAvatar,
  customTitle,
  customMessage,
  titleStyle,
  textStyle,
  customButton,
  description
}) => {
  const { t } = useLocales();

  return (
    <Modal open={open} onClose={onClose} className="ai-modal">
      <Box className="ai-modal__wrapper">
        <Card className="ai-modal__card">
          {/* <img
            src={customAvatar || '/static/images/congrats.svg'}
            alt="ai-avatar"
            className="ai-modal__avatar"
          /> */}
          <Typography variant="h5" fontWeight={600} style={titleStyle}>
            {customTitle || t('The Magic is Working…')}
          </Typography>
          <Typography
            variant="body2"
            fontWeight={400}
            color="#85878C"
            className="ai-modal__message"
            style={textStyle}
          >
            {customMessage ||
              t('AI is working. This may take up to 1 minute. Thank you for your patience!')}
          </Typography>
          {description && (
            <Box className="ai-modal__description-preview">{description}</Box>
          )}
          {customButton}
        </Card>
      </Box>
    </Modal>
  );
};

export default AIModal;
